module.exports = __webpack_public_path__ + "img/aimforseva.7702b8be.png";